import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const get = (url) => () => api.get(url).then((r) => r.data);

export const useServices = () => useQuery({ queryKey: ["services"], queryFn: get("/services") });
export const useCities = () => useQuery({ queryKey: ["cities"], queryFn: get("/cities") });
export const useConfig = () => useQuery({ queryKey: ["config"], queryFn: get("/config") });

export function useServiceMap() {
  const { data = [] } = useServices();
  return Object.fromEntries(data.map((s) => [s.slug, s]));
}

const LOC_KEY = "po_location";
export const loadLocation = () => {
  try {
    return JSON.parse(localStorage.getItem(LOC_KEY));
  } catch (e) {
    return null;
  }
};
export const saveLocation = (loc) => localStorage.setItem(LOC_KEY, JSON.stringify(loc));
export const clearLocation = () => localStorage.removeItem(LOC_KEY);
